import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import ScenarioClass from '../sections/ScenarioClass'
import TitleSection from '../sections/TitleSection'


const ScenariosPage = () => {
  return (
    <div className='__page-container'>
        <Navbar />
        <section className='container'>
          <TitleSection title="AFPRØV ET SCENARIE" body="Brug scenarierne til at diskutere, hvor godt din virksomhed ville klare sig i forskellige fremtidsscenarier. Du kan bl.a. bruge scenarie-generatoren til at skabe dialog med dine kollegaer om fremtiden i jeres virksomhed." />
          <ScenarioClass />
        </section>

        <Footer />
    </div>
  )
}

export default ScenariosPage